









































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';

@Component({ name: 'EditIntegration' })
export default class extends SaascadaVueDialog {

    dialog = false;
    name = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.name = '';
        }
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        this.dialog = false;
    }

}
